<div mat-dialog-title>
  <div>User Not Verified By Plaid</div>
  <div class="close-icon-container" (click)="onButtonClick('close')">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  <div class="line">You can clear Plaid to allow for resubmission and the user will be prompted to try again.</div>
  @if (submitTimes > 1) {
    <div class="line">This user has previously submitted Plaid {{ submitTimes }} times.</div>
  }
  <div class="line">Or, you can manually verify or deny this users ID.</div>
</div>
<div mat-dialog-actions>
  <div class="button-container">
    <div class="verify-deny-buttons">
      <button color="warn" mat-stroked-button data-cy="button-no" (click)="onButtonClick('deny')">
        Deny
      </button>
      <button color="primary" mat-raised-button data-cy="button-yes" (click)="onButtonClick('verify')">Verify</button>
    </div>
    <button color="primary" mat-raised-button data-cy="button-clear" (click)="onButtonClick('clear')">
      Clear Plaid
    </button>
  </div>
</div>
